// extracted by mini-css-extract-plugin
export default {"wrap":"Icon_wrap__Ust18","download":"Icon_download__0Tqth"};